/* eslint-disable no-underscore-dangle */

export default class UserRepository {
  constructor({ memberMode, loggedIn }) {
    this._loggedIn = loggedIn
    this._memberMode = memberMode
  }

  get isGuest() {
    return !this._loggedIn
  }

  get isLoggedIn() {
    return this._loggedIn
  }

  get isMember() {
    return this._memberMode
  }
}
